import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';

/**
*   Interface/model file auto generate for Setting Group
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/


export interface TypedUser_address_book {
    user_address_book_id?: string;
    user_id?: string;
    province_id?: string | number;
    user_address?: string;
    user_address_ward?: string;
    user_address_province?: string;
    user_address_place_id?: string;
    note?: string;
    hash?: string;
    createdAt?: string;
}


type IQuery = TypedUser_address_book & IQueryParams;


/*
* List of all app
*/
export function useGetUserAddressBooks(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["user_address_book/fetch_entity_list", object],
        queryFn: () => axios.get<TypedUser_address_book[]>(`/user_address_book/admin${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: !!object.user_id,
    });
}

/** Chỉ dùng cho bottom bar */
export function useMutateGetUserAddressBooksForButtomBar() {
    return useMutation({
        mutationKey: ["user_address_book/fetch_entity_list"],
        mutationFn: (object: { user_id: string, journey_id: string }) => axios.get<{ from: TypedUser_address_book[], to: TypedUser_address_book[] }>(`/user_address_book/admin/history${helpers.buildEndUrl(object)}`).then(response => response.data),
        retry: 1,
    });
}


export function useDeleteUserAddressBooks() {
    return useMutation({
        mutationKey: ['user_address_book/delete_entity'],
        mutationFn: (user_address_book_id: string) => axios.delete<any>(`/user_address_book/admin/${user_address_book_id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user_address_book/fetch_entity_list'] });
        }

    });
}